import MappingProps, { MappingTypes } from 'types/Mapping';
import _get from 'lodash/get';

interface CustomMappingProps {
  createdAt?: string;
  destination: string;
  id?: string;
  isRequired: boolean;
  isUnique: boolean;
  source: string;
  sourceId?: string;
  type: MappingTypes;
  fromAttributeHeader?: boolean;
  collectionItemCustomType?: string;
  collectionItemType?: string;
}

export default function isMappingUpdated(
  initialMapping: MappingProps,
  submittedMapping: CustomMappingProps,
) {
  const destinationsDontMatch =
    _get(initialMapping, 'destination') !== _get(submittedMapping, 'destination');
  const sourcesDontMatch = _get(initialMapping, 'source') !== _get(submittedMapping, 'source');
  const isUniqueDontMatch = _get(initialMapping, 'isUnique') !== _get(submittedMapping, 'isUnique');
  const isRequiredDontMatch =
    _get(initialMapping, 'isRequired') !== _get(submittedMapping, 'isRequired');
  const typesDontMatch = _get(initialMapping, 'type') !== _get(submittedMapping, 'type');
  const collectionItemCustomTypeDontMatch =
    _get(initialMapping, 'collectionItemCustomType') !==
    _get(submittedMapping, 'collectionItemCustomType');
  const collectionItemTypeDontMatch =
    _get(initialMapping, 'collectionItemType') !== _get(submittedMapping, 'collectionItemType');
  const subSourcesDontMatch =
    _get(initialMapping, `customProps.mappingSubSource`) !==
    _get(submittedMapping, `customProps.mappingSubSource`);

  return (
    destinationsDontMatch ||
    sourcesDontMatch ||
    isUniqueDontMatch ||
    isRequiredDontMatch ||
    typesDontMatch ||
    collectionItemCustomTypeDontMatch ||
    collectionItemTypeDontMatch ||
    subSourcesDontMatch
  );
}
